import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/team/invite`;
const err = (e) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Errore, riprova');

export default function InvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [msg, setMsg] = useState('');
  const [pw, setPw] = useState({ a: '', b: '' });
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/${token}`).then((r) => setInfo(r.data)).catch((e) => setMsg(err(e))); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) { setMsg('Le due password non coincidono'); return; }
    setBusy(true); setMsg('');
    try { await axios.post(`${API}/${token}`, { password: pw.a }); navigate('/portal/login?attivato=1'); } catch (x) { setMsg(err(x)); } finally { setBusy(false); }
  };
  const field = 'w-full h-12 px-4 bg-[#0B0B0B] border border-[#2A2418] rounded-sm text-[#F2F2F2] focus:border-[#D4AF37] outline-none';
  return (
    <div className="min-h-screen bg-[#050505] grid place-items-center px-4" data-testid="invite-page">
      <div className="w-full max-w-md border border-[#2A2418] bg-[#0A0A0A] p-8 rounded-sm">
        <img src="/assets/BOND_wordmark_gold.png" alt="BOND" className="h-8 mb-8" />
        {!info ? <p className="text-sm text-[#C9CCD1]" data-testid="invite-msg">{msg || 'Caricamento…'}</p> : (
          <form onSubmit={submit} className="space-y-4">
            <div><p className="text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] mb-1">{info.company}</p><h1 className="text-2xl text-[#F2F2F2] font-semibold">Attiva il tuo accesso</h1><p className="text-sm text-[#8A8F97] mt-1">{info.name} · {info.email}</p></div>
            <input type="password" required minLength={10} value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} placeholder="Nuova password (min. 10, lettere e numeri)" className={field} data-testid="invite-password" />
            <input type="password" required minLength={10} value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} placeholder="Ripeti la password" className={field} data-testid="invite-password2" />
            <button disabled={busy} className="w-full h-12 bg-[#D4AF37] text-[#050505] font-semibold rounded-sm inline-flex items-center justify-center gap-2" data-testid="invite-submit">{busy && <Loader2 size={16} className="animate-spin" />}Attiva e accedi</button>
            {msg && <p className="text-sm text-[#E37A72]" data-testid="invite-msg">{msg}</p>}
          </form>
        )}
      </div>
    </div>
  );
}
